export default __webpack_public_path__ + "static/features-phone-mobile-af29f0e3688ec26044881a17b31ab262.png";